import { Component, OnInit, HostBinding, 
         trigger, transition, animate,
         style, state } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import { ToastsManager }  from 'ng2-toastr';

import { ShippersData, ShippersService }  from './Shippers.service';


@Component({
  template: require('./ShippersDetails.component.html'),
  providers: [ShippersService
	
	],
  animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.2s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class ShippersDetailsComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }
  
	objShippers: ShippersData;
	errorMessage: string;
	messages: string[];

	// Lookup Arrays
	

	constructor(private route: ActivatedRoute, 
		private router: Router, 
		private toastr: ToastsManager,
		private ShippersService: ShippersService

	) {
		// this.id = parseInt(params.get('id'));
		this.objShippers = new ShippersData();
	}

	ngOnInit() {
		this.route.params
		// (+) converts string 'id' to a number
		// .switchMap((params: Params) => this.ShippersService.getByID(+params['id']))
		.switchMap((params: Params) => this.ShippersService.getByID(params['id']))
		.subscribe((item: ShippersData) => this.objShippers = item);
		this.getLookups();
	}

	deleteShippers(id: number) {
		if (window.confirm('Are you sure you want to delete this Shippers?') == true)
		{
			this.ShippersService.deleteShippers(this.objShippers.ShipperID.toString())
			.subscribe(record => this.router.navigate(['/Shippers']),
				error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error,
				() => { console.log('Shippers record deleted successfully...'); }
			);
		}
	}
	gotoShippersEdit() {
		this.router.navigate(['/Shippers', this.objShippers.ShipperID]);
	}

	gotoShippers() {
		this.router.navigate(['/Shippers']);
	}


	getLookups() {

	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Shippers/ShippersDetails.component.ts